export default __webpack_public_path__ + "static/media/direct-blown.91ee067f.webp";